import styled, { css } from 'styled-components';
import { OPEN_IN_APP_HEIGHT } from '../../../../../profile/body-section/body-sub-sections/OpenInAppBanner/OpenInAppBanner';
import { ThemeColours } from '../../../../styles/ThemeColours';
import { MOBILE_HEADER_HEIGHT, Breakpoint, ZIndex } from '../../../../styles/constants';
import { propSwitch } from '../../../../util/propSwitch';
import { TOP_NAVIGATION_BAR_HEIGHT } from '../../../TopNavigationBar/TopNavigationBar.styles';

const getFilterOffset = () => (props: { enabledFilterOffset?: boolean }) => css`
  top: ${props.enabledFilterOffset
    ? `calc(${MOBILE_HEADER_HEIGHT} + ${OPEN_IN_APP_HEIGHT}px);`
    : MOBILE_HEADER_HEIGHT};
`;

export const RelativeOffset = styled.div<{
  enabledFilterOffset?: boolean;
  topNavExperiment?: boolean;
  inline?: boolean;
}>`
  ${getFilterOffset()}
  overflow: visible;
  position: absolute;
  width: 100%;

  ${Breakpoint.SMALL} {
    margin-top: 0;
    top: 104px;
  }

  ${Breakpoint.MEDIUM} {
    margin-top: ${props =>
      props.topNavExperiment && !props.inline ? TOP_NAVIGATION_BAR_HEIGHT : '0'};
    top: 104px;
  }
`;

export const FloatingContainer = styled.div<{ inline?: boolean }>`
  background-color: ${ThemeColours.white};
  border-bottom: none;
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${MOBILE_HEADER_HEIGHT});
  left: 0;
  max-height: none;
  overflow: hidden;
  overflow-y: scroll;
  padding-bottom: 0px;
  padding-top: 14px;
  position: fixed;
  position: relative;
  width: 100%;
  z-index: ${ZIndex.OVERLAY};

  ${Breakpoint.SMALL} {
    border-bottom: solid 1px ${ThemeColours.mono200};
    height: ${propSwitch('inline', '500px', 'auto')};
    overflow-y: auto;
    padding-bottom: 0px;
    padding-top: 0px;
    position: relative;
    top: 0;
  }
`;
